// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"banner_wrapper__1Nu-A","slide":"banner_slide__QR26q"};